/* eslint-disable no-underscore-dangle */

const removeFormErrors = form => {
  const errors = form.querySelector('.message.is-error');
  if (errors) {
    errors.classList.add('is-hidden');
  }

  Array.from(form.querySelectorAll('.form-error')).forEach(ele => ele.remove());
};

const showUnexpectedError = form => {
  form.querySelector('.message.is-error').classList.remove('is-hidden');
};

const handleFormSuccess = response => {
  const userEmail = response.on24_response.email;
  const webinarTypes = response.webinar_types;
  const webinarUrl = response.meta._webinar_url;

  if (webinarTypes) {
    webinarTypes.forEach(webinarType => {
      if (webinarType.slug === 'on-demand' && webinarUrl) {
        window.location.href = `${webinarUrl}?mode=login&email=${userEmail}`;
      }
    });
  }

  document.querySelector('#webinar-success').removeAttribute('style');
  document.querySelector('#webinar-page-head').remove();
  document.querySelector('#webinar-content').remove();
  document.querySelector('#page-block-content').remove();
  window.scrollTo(0, 0);
};

const handleFormSubmissionErrors = (form, response) => {
  if (response.errors) {
    response.errors.forEach(error => {
      const field = form.querySelector(`#form-row-${error.field}`);

      if (field) {
        const $error = document.createElement('span');
        $error.classList.add('form-error');
        $error.innerText = error.message;
        field.appendChild($error);
      }
    });

    return;
  }

  showUnexpectedError(form);
};

const handleFormSubmission = event => {
  event.preventDefault();
  const form = event.target;
  const formData = new FormData(form);
  removeFormErrors(form);
  const jsonData = {};

  /* eslint-disable no-restricted-syntax */
  for (const [key, value] of formData.entries()) {
    jsonData[key] = value;
  }
  /* eslint-enabled no-restricted-syntax */

  fetch(`${window.restUrl}on24/v1/register`, {
    method: 'POST',
    body: JSON.stringify(jsonData),
    headers: { 'Content-Type': 'application/json' },
  })
    .then(response => response.json())
    .then(response => {
      if (response.status !== 'success') {
        handleFormSubmissionErrors(form, response);
        return;
      }

      handleFormSuccess(response);
    })
    .catch(() => showUnexpectedError(form));
};

const setUpEvents = () => {
  const forms = document.querySelectorAll('.on24-webinar-form');
  Array.from(forms).forEach(form => {
    form.addEventListener('submit', handleFormSubmission);
  });
};

const rearrangeContent = () => {
  const webinarContent = document.getElementById('webinar-main-content');
  const contentContainer = document.getElementById('webinar-body-content');
  if (webinarContent && contentContainer) {
    contentContainer.appendChild(webinarContent);
  }
};

setUpEvents();
rearrangeContent();
